module.exports = __webpack_public_path__ + "static/media/28DGC5.ce63877f.jpg";